import React, { FC } from 'react';

import styles from './modal_full_screen_content.module.scss';

export const ModalFullScreenContent: FC = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};
